import React, { useState } from 'react'

export default function TextForm(props) {

  const [text, setText] = useState("");

  // UpperCase-Function
  const handleUpClick = () => {
    let newText = text.toUpperCase();
    setText(newText);
    props.showAlert("Converted to Uppercase", "Success");
  }

  // LowerCase-Function
  const handleLowClick = () => {
    let newText = text.toLowerCase();
    setText(newText);
    props.showAlert("Converted to Lowercase", "Success");
  }

  // Clear-Function
  const handleClearClick = () => {
    let newText = "";
    setText(newText);
    props.showAlert("Text cleared", "Success");
  }

  // Copy-text-Function
  const handleCopy = () => {
    let text = document.getElementById("myBox");
    text.select();
    navigator.clipboard.writeText(text.value);
    props.showAlert("Text copied in clipboard", "Success");
  }

  // ExtraSpace-Function
  const handleExtraSpaces = () => {
    let cutText = text.split( / [ ] + / );
    setText(cutText.join(" "));
    props.showAlert("Extra spaces cleared", "Success");
  }

  // const handlePaste = async() => {
  //   let pasteText = await navigator.clipboard.readText();
  //   setText(text);
  // }

  // OnChange-Function
  const handleOnChange = (event) => {
    // console.log("Handle On Change");
    setText(event.target.value)
  }

  return (
   <>
   <div className="container1 text-center">
    <h1 className='mt-3'> {props.heading} </h1>
      <div className="mb-3 d-flex align-items-center justify-content-center">
        <textarea
          className="form-control w-75" id="myBox" rows="5" value={text} onChange={handleOnChange} style={{backgroundColor: props.mode === 'dark'?'lightgray':'white'}}
        ></textarea>

      </div>
      <button className="btn btn-primary mx-2" onClick={handleUpClick}>
        Convert to Uppercase
      </button>

      <button className="btn btn-primary" onClick={handleLowClick}>
        Convert to Lowercase
      </button>

      <button className="btn btn-primary mx-2" onClick={handleClearClick}>
        Clear Text
      </button>

      <button className="btn btn-primary" onClick={handleCopy}>
        Copy Text
      </button>

      {/* <button className="btn btn-primary" onClick={handlePaste}>
        Paste Text
      </button> */}

      <button className="btn btn-primary mx-2" onClick={handleExtraSpaces}>
        Cut Spaces
      </button>

    </div>

    <div className="container2 my-5 text-center">
      <h2> Your Text Summary </h2>
      <p>{text.split(" ").length} Words & {text.length} Characters </p>
      <p> {0.007 * text.length} Minutes to read it </p>
      <h3>Preview</h3>
      <p>{text.length>0? text:"Enter something to preview"}</p>
    </div>
   </>
  )
}
